module.exports = __webpack_public_path__ + "static/img/SketchPngb34868e394bd2b0131f3353d47eabedc2828f53a10b01629149abe6281bc0357.8f8f45cb.png";